import { render, staticRenderFns } from "./DetailsForm.vue?vue&type=template&id=4592b83d&scoped=true&"
import script from "./DetailsForm.vue?vue&type=script&lang=js&"
export * from "./DetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailsForm.vue?vue&type=style&index=0&id=4592b83d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4592b83d",
  null
  
)

export default component.exports